export class BulkUploadResultDto {

    unExistingMatricules!: string[];

    notAllowedExtensions!: string[];

    isUploadingFile!: boolean;
}